import styled from 'styled-components';
import { MeetingCameraIcon } from '@rsos/assets/icons';
import { Button } from '@rsos/base-components';

export const LiveVideoButton = styled(Button)`
  width: 100%;
  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const StyledMeetingCameraIcon = styled(MeetingCameraIcon)`
  margin-right: 4px;
`;
